<template>
  <v-dialog v-if="!disabled" :value="isUpdateRecommended" :width="500" @input="close" @keydown.stop.esc="close"
    :content-class="'app-dialog ' + (isMobileOnly ? 'mobile' : '')" :persistent="isUpdateRequired">
    <v-card>
      <v-form ref="changePasswordForm" lazy-validation @submit.prevent="update">

        <v-toolbar class="app-dialog-header">
          <v-toolbar-title>{{$t('appCheckingMobileVersion.title')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="!isUpdateRequired" icon small @click="close">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="app-dialog-body font-weight-bold subtitle-2">
          <div v-if="isUpdateRequired" class="error--text">{{$t('appCheckingMobileVersion.updateRequired')}}</div>
          <div v-else class="warning--text">{{$t('appCheckingMobileVersion.updateRecommended')}}</div>
        </v-card-text>

        <v-card-actions class="app-dialog-footer">
          <v-spacer></v-spacer>
          <v-btn type="submit" color="primary"> {{$t('appCheckingMobileVersion.update')}} </v-btn>
          <v-btn v-if="!isUpdateRequired" color="secondary" @click="close">{{$t('appCheckingMobileVersion.postpone')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { actions as _act } from '@/models/store.actions';
import {
  isNativeApp,
  isNativeAndroid,
  isNativeIos
} from '@/helpers/platform-helper';
import { logger } from '@/helpers/log.service';

export default {
  name: 'AppCheckingMobileVersion',
  inject: ['isMobileOnly'],
  data() {
    return {
      disabled: true,
      isUpdateRecommended: false,
      isUpdateRequired: false
    };
  },
  computed: {
    appSettings() {
      return this.$store.getters[_act.SETT_GET_APPSET];
    },
    currentServerVersion() {
      return this.$store.getters[_act.SETT_GET_SERV_VERS];
    },
    currentClientVersion() {
      return this.$store.getters[_act.SETT_GET_CURENTVERSIONGET];
    },
    maxClientAndServerMinorVersionDiff() {
      let v = 1;
      if (
        this.appSettings &&
        'maxClientAndServerMinorVersionDiff' in this.appSettings
      ) {
        v = +this.appSettings.maxClientAndServerMinorVersionDiff;
        if (isNaN(v)) {
          v = 1;
        }
      }
      return v;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    checkVersionsDifferences() {
      logger.debug(
        `[AppCheckingMobileVersion:checkVersionsDifferences] versions`,
        {
          currentServerVersion: this.currentServerVersion,
          currentClientVersion: this.currentClientVersion
        }
      );
      let {
        major: servMajor,
        minor: servMinor,
        build: servBuild,
        edition: servEdition
      } = this.splitVersion(this.currentServerVersion);
      logger.debug(
        `[AppCheckingMobileVersion:checkVersionsDifferences] parsed server version`,
        { major: servMajor, minor: servMinor, build: servBuild, edition: servEdition }
      );
      let {
        major: clientMajor,
        minor: clientMinor,
        build: clientBuild,
        edition: clientEdition
      } = this.splitVersion(this.currentClientVersion);
      logger.debug(
        `[AppCheckingMobileVersion:checkVersionsDifferences] parsed client version`,
        { major: clientMajor, minor: clientMinor, build: clientBuild, edition: clientEdition }
      );
      if (
        ![servMajor, servMinor, clientMajor, clientMinor].some((v) => v === -1)
      ) {
        let majorDiff = servMajor - clientMajor;
        let minorDiff = servMinor - clientMinor;
        logger.debug(
          `[AppCheckingMobileVersion:checkVersionsDifferences] majorDiff=${majorDiff} minorDiff=${minorDiff}        `
        );
        this.isUpdateRequired =
          majorDiff > 0 || minorDiff > this.maxClientAndServerMinorVersionDiff;
        this.isUpdateRecommended = this.isUpdateRequired || minorDiff > 0;
        this.disabled = false;
        logger.debug(
          `[AppCheckingMobileVersion:checkVersionsDifferences] isUpdateRequired=${this.isUpdateRequired} isUpdateRecommended=${this.isUpdateRecommended}        `
        );
      }
    },
    close() {
      if (!this.isUpdateRequired) {
        this.isUpdateRecommended = false;
      }
    },
    init() {
      if (isNativeApp()) {
        this.checkVersionsDifferences();
      } else {
        this.disabled = true;
      }
    },
    splitVersion(v) {
      let major = -1;
      let minor = -1;
      let build = -1;
      let edition = -1;
      if (v) {
        const arr = v.split('.');
        if (arr && arr.length) {
          major = +arr[0];
          if (arr.length > 1) {
            minor = +arr[1];
          }
          if (arr.length > 2) {
            build = +arr[2];
          }
          if (arr.length > 3) {
            edition = +arr[3];
          }
        }
      }
      return { major, minor, build, edition };
    },

    update() {
      if (isNativeAndroid()) {
        window.open(`market://details?id=com.infoplus.askod.online`);
      } else if (isNativeIos()) {
        window.open(`itms-apps://itunes.apple.com/app/1560671518`);
      }
    }
  }
};
</script>
